<template>
  <section class="payslips border border-[#CACACA] !p-[16px] rounded-[8px] mt-5">
    <div class="section-header items-center" @click="toggleSection">


      <div class="flex gap-2 cursor-pointer">
        <span class="flex flex-col justify-center">
            <h1 class="text-[12px] text-left flex" style="font-weight: 800;">{{ title }}</h1>
        </span>
        <icon v-if="info" icon-name="icon-info" class="cursor-pointer text-flame" size="xs"
            v-tooltip.bottom="info" />
    </div>
    <label class="switch mx-3" v-if="showToggle">
      <input
        type="checkbox"
        :checked="checked"
        @change="$emit('toggle-change', $event.target.checked)"
      />
      <span class="slider round"></span>
    </label>

      <div class="flex items-center ml-auto">
          <div v-if="showFrequency" class="flex items-center w-[100px] border-r mr-3 pr-3"  @click.stop>
            <CSelect
              placeholder="Enter"
              :options="optionsPeriod"
              v-model="selectedFrequency"
              class="accordion h-[20px] mr-2 !w-full"
              style="height: 26px;"
              :rules="['required']"
              @input="handleFrequencyChange"
              :disabled="disabled"
            />
        </div>

        <div
          class="text-flame !ml-auto font-semibold border-r mr-3 pr-3  flex items-center text-base cursor-pointer"
          style="margin-left: auto;"
          v-if="showToggle"
          @click.stop="addModerator"
        >
          <icon icon-name="icon-plus" class="mr-2" size="xsm" />
          Add Moderator
        </div>
        <Icon
          icon-name="chevronDown"
          class="cursor-pointer chevron"
          :class="{ rotated: isOpenState }"
        />
      </div>

    </div>
    <div v-if="isOpenState">
      <p class="subtitle text-[14px] font-400 border-b border-[#CACACA] pb-4">{{ subtitle }}</p>
      <slot></slot>
    </div>
  </section>
</template>

  <script>
  import CSelect from "@scelloo/cloudenly-ui/src/components/select";

  export default {
    name: 'PerformanceAccordion',
    components: {
        CSelect,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      info: {
        type: String,
        default:'',
        required: false,
      },
      subtitle: {
        type: String,
        required: false,
        default: ''
      },
      showToggle: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: true
    },
    addModerator: {
      type: Function,
      default: () => {}
    },
    showFrequency: {
      type: Boolean,
      default: false
    },
    initialFrequency: {
      type: String,
      default: ''
    },
    editAppraisal: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
    },
    data() {
      return {
        isOpenState: this.isOpen,
        selectedFrequency: this.initialFrequency,
        optionsPeriod: [
        { id: 1, name: "Annual" },
        { id: 2, name: "BiAnnual" },
        { id: 4, name: "Quarterly" },
        { id: 5, name: "Custom" },
      ],
      };
    },
    watch: {
      isOpen: {
        immediate: true,
        handler(newValue) {
          this.isOpenState = newValue;
        }
      },
      initialFrequency: {
        immediate: true,
        handler(newValue) {
          this.selectedFrequency = newValue;
        }
      }
    },
    methods: {
      toggleSection() {
        this.isOpenState = !this.isOpenState;
      },
      handleFrequencyChange(value) {
        this.$emit('frequency-change', value);
      }
    },
  };
  </script>

  <style scoped>
::v-deep .accordion > label {
  display: none !important;
}
::v-deep .accordion > .cloudenly-input {
  height: 100% !important;
}

  .payslips {
      padding: 16px;
      border: 1px solid #CACACA;
      border-radius: 8px;
  }

  h2 {
      font-size: 16px;
      font-weight: 600;
  }

  .section-header {
      display: flex;
      align-items: center;
      cursor: pointer;
  }

  .subtitle {
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 15px;
  }



  .warning .icon {
      margin-right: 10px;
      font-size: 18px;
  }

  .option {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #e5e5e5;
  }

  .option:last-of-type {
      border-bottom: none;
  }

  .option-details {
      display: flex;
      flex-direction: row;
  }

  .option-details p {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
  }

  .info-link {
      font-size: 12px;
      color: #007bff;
      text-decoration: none;
  }

  .info-link:hover {
      text-decoration: underline;
  }

  /* Toggle switch */
  .switch {
      position: relative;
      display: inline-block;
      width: 24px;
      height: 12px;
  }

  .switch input {
      opacity: 0;
      width: 0;
      height: 0;
  }

  .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #EEEEEE;
      transition: 0.4s;
      border-radius: 20px;
  }

  .slider:before {
      position: absolute;
      content: "";
      height: 9.6px;
      width: 9.6px;
      border-radius: 50%;
      left: 2px;
      bottom: 1.5px;
      background-color: #878E99;
      transition: 0.4s;
  }



  input:checked+.slider:before {
      transform: translateX(10px);
      background-color: #13B56A;

  }

  .slider.round {
      border-radius: 34px;
  }

  .slider.round:before {
      border-radius: 50%;
  }

  /* Chevron icon */
  .chevron {
      font-size: 14px;
      transition: transform 0.3s ease;
  }

  .chevron.rotated {
      transform: rotate(180deg);
  }
  </style>
